<template>
  <div class="package-edit-form-container ml-10">
    <app-filter
      :filter-list="table_filter"
      default-label-width="100px"
      @search="search"
    />
    <div class="text-right">
      <el-button size="mini" type="success" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app_table_ref"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :get-data="getSiteList"
      :table-props="{
        'max-height': '450px',
      }"
      :check="true"
      check-key="id"
      :is-reserve-checked="true"
      :is-row-click="true"
      @select-tr="selectionChange"
      @hook:mounted="onTableMounted"
    />
  </div>
</template>

<script>
import { getSiteListApi, pullSiteListApi } from '@/api/tool/site';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    // 渠道接口
    channelInterface: {
      type: String,
      required: true,
    },
    // 广告主ID
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    // 已选中的落地页
    value: {
      type: Array,
      required: true,
    },
    // 落地页列表接口额外传参
    extraParams: {
      type: Object,
      required: true,
    },

  },
  data() {
    return {
      /** 过滤项配置 */
      table_filter: require('./model/table-filter.js')(this),
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },
      assignSelection: [],
    };
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.app_table_ref.seekTable();
    },
    /**
     * 获取落地页列表
     * @param {Object} params 接口参数
     */
    getSiteList(params) {
      return new Promise((resolve) => {
        const { name, ...rest } = params;
        const filtering = {
          ...(name && { name }),
          ...this.extraParams,
        };
        getSiteListApi({
          channel_interface: this.channelInterface,
          advertiser_id: this.advertiserId,
          filtering,
          ...rest,
        }).then(resolve);
      });
    },
    /** 同步落地页列表 */
    onPull() {
      pullSiteListApi({
        channel_interface: this.channelInterface,
        advertiser_id: this.advertiserId,
      }).then((res) => {
        this.$message.success(res.message || '同步成功');
        this.$refs['app_table_ref'].seekTable();
      });
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     */
    selectionChange(rows) {
      this.assignSelection.splice(0);
      this.assignSelection.push(...rows);
    },
    /**
     * 获取分配表单已选项
     * @returns {Promise<Object[]>}
     */
    async getAssignSelection() {
      return Promise.resolve(this.assignSelection);
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const app_table_ref = this.$refs.app_table_ref;

      this.assignSelection.splice(0);
      this.assignSelection.push(...this.value);

      app_table_ref?.multipleSelection?.splice(0);
      app_table_ref?.multipleSelection?.push(...this.assignSelection);
      app_table_ref?.multipleSelectionAll?.splice(0);
      app_table_ref?.multipleSelectionAll?.push(...this.assignSelection);
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
  },
};
</script>
